module.exports = __webpack_public_path__ + "img/wx_cz.28d584e6.jpg";